module.exports = "<p>\n  addratemodal works!\n</p>\n"